import { atcb_action } from 'add-to-calendar-button/no-pro';

class AddToCalendarButton {
  constructor(element) {
    this.button = element;
    this.title = document.getElementById("event-title").textContent.trim();
    this.arrivalDate = document.getElementById("stay-arrival").textContent.trim();
    this.departureDate = document.getElementById("stay-departure").textContent.trim();

    // Updated config object with potential changes in the new version
    this.config = {
      name: this.title,
      startDate: this.formatDate(this.arrivalDate),
      endDate: this.formatDate(this.departureDate),
      options: ['Google', 'Outlook.com', 'Apple'],
      timeZone: 'Europe/Berlin',
      iCalFileName: 'Reminder-Event',
      listStyle: 'dropdown',
      trigger: 'click',
      location: '',
      description: '',
      buttonStyle: 'default',
      hideBranding: true,
    };
    
    this.initialize();
  }
 
  // Helper method to format date if needed
  formatDate(dateStr) {
    const date = new Date(dateStr);
    return date.toISOString().split('T')[0]; // Formats to YYYY-MM-DD
  }

// Initialize the event on the button
  initialize() {
    this.button.addEventListener('click', () => this.handleClick());
  }

  handleClick() {
    atcb_action(this.config, this.button);
  }
}

// Initialize the "Add to Calendar" buttons
const calendarButtons = document.querySelectorAll('[data-add-to-calendar]');
calendarButtons.forEach((button) => {
  button.AddToCalendarButton = new AddToCalendarButton(button);
});